import React, { useState, useCallback, useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import IconRail, { RAIL_WIDTH } from './IconRail';
import FlyoutPanel from './FlyoutPanel';
import TopBar from './TopBar';
import { pillars } from './navConfig';

export default function AppShell({ children }) {
  const [activePillar, setActivePillar] = useState(null);
  const location = useLocation();

  const handlePillarClick = useCallback((pillarId) => {
    setActivePillar((prev) => (prev === pillarId ? null : pillarId));
  }, []);

  const handleCloseFlyout = useCallback(() => {
    setActivePillar(null);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') handleCloseFlyout();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [handleCloseFlyout]);

  // Determine which pillar is contextually active based on route
  const currentPillar = pillars.find(
    (p) => location.pathname === p.basePath || location.pathname.startsWith(p.basePath + '/')
  );

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <IconRail
        activePillar={activePillar || currentPillar?.id}
        onPillarClick={handlePillarClick}
        onSettingsClick={() => {}}
      />

      {activePillar && (
        <FlyoutPanel pillarId={activePillar} onClose={handleCloseFlyout} />
      )}

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', ml: `${RAIL_WIDTH}px` }}>
        <TopBar />
        <Box component="main" sx={{ flex: 1, p: 3, overflow: 'auto' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
